import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./CustomSoftware.css";

import customsoftware from "../../assests/CustomSoftware.svg"
import heroImg from "../../assests/Background-img.svg";

// Components
import ARVRSecondpage from "../Ar-vrServicespage/ARVRSecondpage";

import ContactFormModal from "../header/ContactFormModal";
import CoreServices from "../coreServices/coreServices";
import BusinessValue from "../BusinessValue/BusinessValue";
import WhyIOTSection from "../WhyIOTSection/WhyIOTSection";
import ArBusiness from "../Ar-vrServicespage/ArBusiness";
import SoftwareCoreServices from "../SoftwareCoreServices/SoftwareCoreServices";
import { useNavigate } from "react-router-dom";
// Define service type  
type Service = {
  id: string;
  title: string;
  icon: string;
  items: string[];
  hasRoute: boolean;
  routePath?: string;
};

const CustomSoftware: React.FC = () => {
  const navigate = useNavigate();
  const [activeService] = useState("ar");
    const [showContactForm, setShowContactForm] = useState(false);

  const handleServiceClick = (service: Service) => {
    if (service.hasRoute && service.routePath) {
      window.location.href = service.routePath;
    }
  };

  return (
    <div className="custom-services-page">
      {showContactForm && <ContactFormModal onClose={() => setShowContactForm(false)} />}
      {/* Hero Section */}
<section
  className="hero-section-custom d-flex align-items-center justify-content-center"
  style={{
    backgroundImage: `url(${heroImg})`,
    backgroundSize: "cover",
  }}
>
  <div className="container-custom text-center">
    <h1 className="hero-title-custom">Digital Engineering</h1>
    <p className="hero-subtitle-custom">
      At Drive digital transformation with end-to-end engineering solutions.
    </p>
    <button
      className="hero-button-custom"
      onClick={() => navigate("/Contact-Us")}
    >
      Get in Touch
    </button>
  </div>
</section>

      {/* Other Sections */}
      <SoftwareCoreServices/>
      <BusinessValue/>
      <WhyIOTSection/>
      <ArBusiness/>
    </div>
  );
};

export default CustomSoftware;
